import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify';
import store from './store'
import axios from 'axios'
import './plugins'
import {apiHost} from '@/config/config';
import io from 'socket.io-client';
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";
import { v4 as uuidv4 } from 'uuid';

Vue.config.productionTip = false

Vue.prototype.$http = axios;
Vue.prototype.$axios = axios;
Vue.prototype.$store = store;
Vue.prototype.$apiHost = apiHost;

Vue.use(Toast, {
  transition: "Vue-Toastification__fade",
  maxToasts: 3,
  newestOnTop: true
});

// Initialize socket connection at the application level
if (localStorage.accessToken) {
  const token = localStorage.accessToken;
  let base64Url = token.split(".")[1];
  let base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
  let jsonPayload = decodeURIComponent(
    atob(base64)
      .split("")
      .map(function(c) {
        return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
      })
      .join("")
  );
  let user = JSON.parse(jsonPayload);
    let userId = sessionStorage.getItem('userId');
    if (!userId) {
      userId = user.id;
      sessionStorage.setItem('userId', userId);
    }
    const socketId = uuidv4();

    Vue.prototype.$socket = io(apiHost, {
      auth: {
        token: localStorage.accessToken
      },
      query: {
        userId: userId,
        socketId: socketId
      }
    });    
    Vue.prototype.$socket.on('connect_error', async (error) => {
      console.log(`socket error: ${error}`);
      const errorString = String(error);
      if (errorString.includes('Invalid token')) {
        const res = await axios.get(`${apiHost}/reissue/token`);
        if (res.statusText === 'OK') {
          localStorage.accessToken = res.data.accessToken;
          localStorage.refreshToken = res.data.refreshToken;
          location.reload();
        }
      }
    });
    Vue.prototype.$socket.on('connect_success', (msg) => {
      console.log(`${msg}`);
    });
    Vue.prototype.$socket.on('resultToast', (msg) => {
      Vue.prototype.$toast.success(`${msg.analysisName} analysis is completed.`, {
        position: "bottom-right",
        timeout: false,
        closeOnClick: true,
        pauseOnFocusLoss: true,
        pauseOnHover: true,
        draggable: true,
        draggablePercent: 0.6,
        showCloseButtonOnHover: false,
        hideProgressBar: true,
        closeButton: "button",
        icon: true,
        rtl: false
      });
    });
    Vue.prototype.$socket.on('reassignId', (newId) => {
      sessionStorage.socketId = newId;
    });
    Vue.prototype.$socket.on('academicResultToast', (msg) => {
      Vue.prototype.$toast.success(`Academic report generation for the ${msg.analysisName} has been completed.`, {
        position: "bottom-right",
        timeout: false,
        closeOnClick: true,
        pauseOnFocusLoss: true,
        pauseOnHover: true,
        draggable: true,
        draggablePercent: 0.6,
        showCloseButtonOnHover: false,
        hideProgressBar: true,
        closeButton: "button",
        icon: true,
        rtl: false
      });
    });
    Vue.prototype.$socket.on('noticeToast', (msg) => {
      Vue.prototype.$toast.info(`${msg.message}`, {
        position: "top-center",
        timeout: false,
        closeOnClick: true,
        pauseOnFocusLoss: true,
        pauseOnHover: true,
        draggable: true,
        draggablePercent: 0.6,
        showCloseButtonOnHover: false,
        hideProgressBar: true,
        closeButton: "button",
        icon: true,
        rtl: false
      });
    });
}

// refreshToken
axios.interceptors.request.use(
  request => {
    request.headers['x-access-token'] = localStorage.accessToken;
    const url = request.url.split('/');
    if (url.find(v => v == 'reissue')) {
      request.headers['x-refresh-token'] = localStorage.refreshToken;
    }
    return request;
  }
);
axios.interceptors.response.use(
  async response => {
    if (response.data.runReissue) {
      const res = await axios.get(`${apiHost}/reissue/token`);
      if (res.data.reissue) {
        localStorage.accessToken = res.data.accessToken;
        localStorage.refreshToken = res.data.refreshToken;
      }
      const result = await axios(response.config);
      return result;
    }
    return response
  },
  async function handleError(error) {
    if (error.response.status == 403) {
      if (window.location.pathname.substring(1) !== '') {
        // router.push({ name: 'SignIn' });
        Vue.prototype.$store.dispatch("SIGNOUT").then(() => {
          location.reload();
        });
      }
      return Promise.reject('login expiration(refresh token expired)');
    }
    return Promise.reject(error);
  }
);

new Vue({
  router,
  vuetify,
  store,
  async mounted() {
    await this.$nextTick();
    
    const waitForSocketConnection = () => {
      return new Promise((resolve) => {
        if (this.$socket && this.$socket.connected) {
          sessionStorage.socketId = Vue.prototype.$socket.id
          resolve();
        } else {
          setTimeout(() => {
            waitForSocketConnection().then(resolve); // 재시도 후에 resolve 호출
          }, 100);
        }
      });
    };
    
    await waitForSocketConnection();
    
    await axios.get(`${apiHost}/socket/checkToast`);
  },
  render: h => h(App)
}).$mount('#app');